<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addressDialog"
        persistent
        max-width="350px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('customer.addAddressTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                :value="isDone"
                type="success"
              >
                {{ $t('common.addedSuccessfully') }}
              </v-alert>
              <v-alert
                :value="isFailed"
                type="error"
              >
                {{ $t('customer.addressIsRequired') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout>
                  <v-flex
                    class="px-2"
                    xs12
                    sm3
                    md3
                  >
                    <v-select
                      autocomplete
                      :items="governoratesList"
                      item-value="governorate_id"
                      item-text="governorate_name"
                      v-validate="'required'"
                        v-model="selectedGovernorateId"
                        :error-messages="errors.collect('Governorate')"
                        data-vv-name="Governorate"
                        :label="$t('columns.governorate')"
                        clearable
                        @input="onGovernorateChange"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    class="px-2"
                    xs12
                    sm3
                    md3
                  >
                    <v-select
                      autocomplete
                      :items="filteredCitiesList"
                      item-value="city_id"
                      item-text="city_name"
                      v-validate="'required'"
                      v-model="form.city_id_fk"
                      :error-messages="errors.collect('City')"
                      data-vv-name="City"
                      :label="$t('columns.city')"
                      clearable
                      :disabled="!selectedGovernorateId"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    xs12
                    sm3
                    md3
                  >
                    <v-text-field
                      :label="$t('columns.address') + '*'"
                      v-model="form.address"
                      :error-messages="errors.collect('address')"
                      v-validate="'required|min:3'"
                      data-vv-name="address"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-7pct"
                outline
                color="success"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
export default {
  props: ['addressDialog', 'governoratesList', 'citiesList', 'customer'],

  data() {
    return {
      form: {},
      isDone: false,
      isFailed: false,
      selectedGovernorateId: null,
      filteredCitiesList: []
    }
  },

  methods: {
    onGovernorateChange() {
      // Clear city selection when governorate changes
      this.form.city_id_fk = null
      if (this.selectedGovernorateId) {
        const token = localStorage.getItem('access_token')
        Axios.get(`api/city/list/${this.selectedGovernorateId}`, {
          headers: { Authorization: 'Bearer ' + token }
        }).then((response) => {
          this.filteredCitiesList = response.data
        }).catch(() => {
          this.filteredCitiesList = []
        })
      } else {
        this.filteredCitiesList = []
      }
    },
    closeDialog() {
      this.form = {}
      this.isDone = false
      this.isFailed = false
      this.selectedGovernorateId = null
      this.filteredCitiesList = []
      this.$validator.reset()
      this.$emit('close')
      this.$emit('resetTable')
    },
    submitForm() {
      this.isDone = false
      this.isFailed = false
      this.$validator.validateAll().then((res) => {
        if (res) {
          var token = localStorage.getItem('access_token')
          this.form.full_name = this.customer.full_name
          this.form.phone_number = this.customer.phone_number
          this.form.governorate_id_fk = this.selectedGovernorateId
          Axios.put(`api/update-customer/${this.customer.user_id}`, this.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(() => {
            this.isDone = true
            this.$emit('refetchUser')
            setTimeout(() => {
              this.closeDialog()
            }, 2000)
          }).catch(() => {
            this.isFailed = true
          })
        }
      })
    }
  },
  watch: {
    addressDialog(val) {
      // When dialog opens, if governorate is selected, load cities
      if (val && this.selectedGovernorateId) {
        this.onGovernorateChange()
      }
    }
  },

}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/addAddress.vue